export default () => {
  setTimeout(() => {
    return window.scroll({ top: 0, behavior: "smooth" });
  }, 500);
}